<template>
  <div>
    <article>
      <header>
        <h2>Newsletter Abonnenten</h2>
      </header>
      <main>
        <p>
          Die nachfolgende Liste zeigt alle aktiven Newsletter-Abonnenten.
          Sobald ein Abonnement gekündigt wird, wird auch der Eintrag in dieser Liste entfernt und der Registrierungsprozess muss erneut über die Hauptseite gestartet werden.
        </p>
        <table>
          <thead>
            <th>Nr.</th>
            <th>E-Mail</th>
          </thead>
          <tbody>
            <tr v-for="(subscriber, index) in subscribers">
              <td>{{ index + 1 }}</td>
              <td>{{ subscriber.email }}</td>
            </tr>
          </tbody>
        </table>
      </main>
    </article>
  </div>
</template>
<script>

import adminRequest from "@/mixins/admin-request";

export default {
  mixins: [adminRequest],
  data() {
    return {
      subscribers: null,
    }
  },
  mounted() {
    this.loadSubscriptions()
  },
  methods: {
    loadSubscriptions() {
      this.adminRequest('GET', 'admin/newsletter/subscriptions', res => {
        this.subscribers = res.data
      })
    }
  }
}

</script>
<style scoped lang="scss">

table {
  width: 100%;

  thead {
    th {
      text-align: left;
    }
  }

  th, td {
    padding-right: 1em;

    &:last-child {
      padding-right: 0;
    }
  }
}

</style>
